import {
  palette,
} from '@primeuix/themes';

export default function setThemeColors(headerColor: string | undefined, buttonsColor: string | undefined): void {
  const root: HTMLElement = document.querySelector(':root')!;

  if (headerColor) {
    root.style.setProperty('--app-header-color-primary', hexToRgb(headerColor));
  }

  if (buttonsColor) {
    const newPalette = palette(buttonsColor);

    // TODO: STUB - PrimeVue built-in mechanism doesn't work for some reason
    // const newPreset = updatePrimaryPalette(palette(buttonsColor));
    for (const [key, value] of Object.entries(newPalette)) {
      root.style.setProperty(`--p-primary-${key}`, value);
    }
  }
}

function hexToRgb(hex: string): string | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `${Number.parseInt(result[1], 16)},${Number.parseInt(result[2], 16)},${Number.parseInt(result[3], 16)}` : null;
}
